<template>
  <q-card
    class="bg-transparent"
    flat
  >
    <q-card-section
      v-if="!$isLandscapeView()"
      class="q-px-sm q-pt-sm q-pb-none relative-position"
    >
      <div
        v-if="showing.loading"
        style="min-height: 100px;"
      >
        <q-spinner
          class="absolute-center"
          size="5.5em"
        />
      </div>
      <movie-card
        v-else-if="showing.loaded"
        :showing="showing"
        :movie="showing.movie"
        @movie-selected="$emit('movie-selected')"
      />
    </q-card-section>

    <login
      class="q-pa-md q-mx-auto"
      flat
      hide-register-button
      bg-transparent
      dense
      :autofocus-enabled="false"
      :consumer-login="!$kiosk"
      :kiosk-login="$kiosk"
      @register="() => $router.push('/register-user')"
      @login-success="(userId) => $emit('login-success', userId)"
    >
      <template #header>
        <div class="text-h6 q-my-sm text-center">
          {{ $tc('auth.alreadyHaveAnAccountQuestion') }}
        </div>
      </template>
      <template #default>
        <div class="text-center">
          <div class="text-h6 q-mb-sm">
            {{ $t('checkout.registerPromptTitle') }}
          </div>
          <div class="text-body2 q-mb-sm">
            {{ $t('checkout.registerPromptDescription', { rewardsCurrencyName: currentCircuit.rewardsCurrencyName }) }}.
          </div>
        </div>
        <q-btn
          class="full-width q-mb-sm"
          size="lg"
          color="secondary"
          :text-color="$getColor(currentSite, 'secondary')"
          :label="$t('auth.actions.signup')"
          @click="$router.push('/register')"
        />
        <q-btn
          class="full-width q-mb-small"
          size="lg"
          color="primary"
          outline
          :label="$t('checkout.actions.continueAsGuest')"
          data-test-id="continue-as-guest-button"
          @click="$emit('continue-as-guest')"
        />
      </template>
    </login>
  </q-card>
</template>

<script>
import Showing from 'src/models/showing/Showing'
import Login from 'src/modules/auth/pages/Login'
import MovieCard from 'src/modules/checkout/components/MovieCard'
export default {
  name: 'LoginAndGuestCheckoutCard',
  configuration: ['currentCircuit', 'currentSite'],
  components: {
    Login,
    MovieCard
  },
  props: {
    showing: {
      type: Showing,
      required: true
    }
  },
  emits: ['movie-selected', 'login-success', 'continue-as-guest']
}
</script>
